import { Heading1Mixin } from '@qover/typography';
import styled, { createGlobalStyle } from 'styled-components';

export const ChatStyle = createGlobalStyle`
  .zEWidget-launcher.zEWidget-launcher--active {
    @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
      display: none;
    }
  }
`;

// Do not change padding-[bottom|top] to padding
export const Container = styled.div<{ maxWidth?: string }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 20px -20px 0 -20px;
  max-width: 100%;
  width: 100%;

  > * {
    width: 100%;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    max-width: ${props => props.maxWidth || '935px'};
    margin-top: 40px;
    width: 100%;
  }

  &.mt-0 {
    margin-top: 0;
  }
`;

export const PageContainer = styled.div`
  color: var(--color-text-quote-100);
  background-color: var(--color-card-background-100);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 30px;

  > h2 {
    margin: 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    padding: 60px 20px 70px;
  }
`;

export const ConfirmationTitle = styled.h1`
  ${Heading1Mixin};

  p {
    margin: 0;
  }
`;
